import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@/environments/environment';

export const XAppInterceptor: HttpInterceptorFn = (req, next) => {
  const emptyGuid = '00000000-0000-0000-0000-000000000000';

  // Use languageGuid key, fallback to default English GUID
  const languageGuid = localStorage.getItem('languageGuid') ?? '24c9b00d-d028-4e04-a1aa-f04d2dcae2c3';

  const modifiedRequest = req.clone({
    headers: req.headers
      .set('X-App', environment.appId)
      .set('X-Enterprise', localStorage.getItem('enterpriseId') ?? emptyGuid)
      .set('X-Auth-Token', 'Bearer ' + (localStorage.getItem('token') ?? ''))
      .set('X-Locale', languageGuid),
  });
  
  return next(modifiedRequest);
};

